import axios from 'axios';
import {ref, onMounted} from 'vue';

import {URLS} from '../config';

export function useGetUsers() {
  const users = ref([]);
  const usersLoading = ref(false);

  const getUsers = async () => {
    usersLoading.value = true;

    try {
      const response = await axios.get(URLS.GET_USERS);
      users.value = response.data.users;
    } catch (error) {
      console.error(error);
    } finally {
      usersLoading.value = false;
    }
  };

  onMounted(() => {
    getUsers();
  });

  return {
    users,
    usersLoading,
  };
}
